import API from '../config/api';

const ENDPOINTS = {
  image: { path: '/upload-image', field: 'image', urlKey: 'imageUrl' },
  audio: { path: '/upload-audio', field: 'audio', urlKey: 'audioUrl' },
  video: { path: '/upload',       field: 'video', urlKey: 'videoUrl' },
};

// Upload a File to Supabase Storage via the backend and return its public URL.
// type ∈ {'image', 'audio', 'video'}. Throws on failure.
export async function uploadMedia(file, type) {
  const cfg = ENDPOINTS[type];
  if (!cfg) throw new Error(`Unsupported media type: ${type}`);

  const formData = new FormData();
  formData.append(cfg.field, file);

  const res = await fetch(`${API.MEDIA}${cfg.path}`, {
    method: 'POST',
    body: formData,
    credentials: 'include',
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Upload failed (${res.status})`);
  }
  const url = data[cfg.urlKey] || data.url;
  if (!url) throw new Error('Upload succeeded but no URL returned');
  return url;
}
